import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = ({ data = [], regimeType = "old" }) => {
  const labels = data.map((item, index) => {
    if (!item && typeof item !== "number") return `Item ${index + 1}`;
    if (typeof item === "number") return `Item ${index + 1}`;
    return item.name || item.label || item.month || item.range || `Item ${index + 1}`;
  });

  const counts = data.map((item) => {
    if (item == null) return 0;
    if (typeof item === "number") return item;
    return Number(item.count ?? item.value ?? item.total ?? 0);
  });

  const amounts = data.map((item) => {
    if (item == null) return 0;
    if (typeof item === "number") return 0;
    return Number(item.amount ?? item.taxAmount ?? 0);
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: "Number of Employees",
        data: counts,
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return null;
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, "#7b2ff7");
          gradient.addColorStop(0.5, "#9f5cff");
          gradient.addColorStop(1, "#d17fff");
          return gradient;
        },
        borderRadius: 6,
        maxBarThickness: 60,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: `${regimeType === "old" ? "Old Regime" : "New Regime"} Slab Distribution`,
        color: "#fff",
        font: { size: 14 },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const index = context.dataIndex;
            const count = counts[index] || 0;
            const amount = amounts[index] || 0;
            return [`Employees: ${count}`, `Tax Amount: ₹${amount.toLocaleString("en-IN")}`];
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ccc",
          font: { size: 12 },
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ccc",
          font: { size: 12 },
        },
        grid: {
          color: "rgba(255,255,255,0.1)",
        },
        title: {
          display: true,
          text: "Employees",
          color: "#ccc",
          font: { size: 14 },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", minHeight: "260px" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default BarChart;
